
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:myProfile:BeforeUpdate', function(event){
    var checkSubscription = Flits('.flits-desktop-view').find('.flits-general-subscription').is(':checked');
    if(Flits('.flits-account-section.flits-desktop-view').css("display") == 'none'){
      checkSubscription = Flits('.flits-mobile-view').find('.flits-general-subscription').is(':checked');
    }
    var e_data =  event.detail.params;
    var accept_marketing_val = checkSubscription ? 1 : 0
    e_data.push({"name":"accepts_marketing","value":(checkSubscription) ? 1 : 0}); 
    checkSubscription ? Flits(".flits-accepts-marketing-label").html(Flits.t('Flits.locals.profile_page.news_letter_yes', 'Stay updated with the latest allergy-related products and deals via email!')) : Flits(".flits-accepts-marketing-label").html(Flits.t('Flits.locals.profile_page.news_letter_yes', 'Stay updated with the latest allergy-related products and deals via email!'))
  })

    Flits(document).on('Flits:Navigation:Loaded', function(event){
     let data = event.detail.settings.navs;
     for (let index = 0; index < data.length; index++) {
       let tab = data[index];
       if(tab.url === "#referFriend"){
          data.splice(11, 0, tab);
          break;
       }
       
     }
    })
  
  function validateEmailWithPlus (data) {
            let testData = /^\w+([\.-]?[\w+])*@[\w+]+([\.-]?[\w+])*([\.]\w{2,3})+$/;
            if (testData.test(data)) {
                return true
            }
            return false
        }
  Flits(document).on('Flits:myProfile:Validate', function(event){
    Flits.myProfile.settings.emailid = Flits(".flits-desktop-view .flits-profile-form [name='email']").val();
    if(!Flits.myProfile.settings.emailValid){
      Flits.myProfile.settings.emailValid = validateEmailWithPlus(Flits.myProfile.settings.emailid);
    }
  })

  Flits(document).on('Flits:setPhoneCountryCode:Loaded',function(event) {
    let settings = event.detail.settings;
    settings.country_list =[{
				countryName: "United States",
				code: "US",
				phoneCode: "1"
			}]
  })

  
  Flits(document).on('Flits:howToEarnCredit:Loaded', function(event){
      var icon_change = event.detail.settings.rulesConfig;
      for (const property in icon_change) {        
        let rules_icon = icon_change[property];
        let path = rules_icon.icon;
        let decoded = atob(path); 
        decoded = decoded.replace(/25d872|25D872|56b46b/g, "904243");
        rules_icon.icon = btoa(decoded)      
    }
});

    Flits(document).on('Flits:myProfile:Loaded', function() {
      if(Flits.AccountPage.settings.active_tab){
        Flits(".flits-profile-form-container").css("opacity","0");
      }
     
     setTimeout(() =>  {
         let dob = Flits("[data-flits-birthdate]").attr("data-flits-birthdate");
        // let bDay = new Date(dob).getDate();
        // bDay = bDay < 10 ? "0" + bDay : bDay;
        // let bMonth = new Date(dob).getMonth() + 1;
        // bMonth = bMonth < 10 ? "0" + bMonth : bMonth;
        // let bYear = new Date(dob).getFullYear();
        let bDay;
        let bMonth;
        let bYear
        if(!Flits.isNull(dob)){
          dob = dob.split("-");
          bDay = dob[2];
          if(bDay.length == 1){
          bDay = bDay < 10 ? "0" + bDay : bDay;
        }
        bMonth = dob[1];
        if(bMonth.length == 1){
          bMonth = bMonth < 10 ? "0" + bMonth : bMonth;
        }
          bYear = dob[0];
        }else{
          bDay = new Date(dob).getDate();
          bDay = bDay < 10 ? "0" + bDay : bDay;
          bMonth = new Date(dob).getMonth() + 1;
          bMonth = bMonth < 10 ? "0" + bMonth : bMonth;
          bYear = new Date(dob).getFullYear();
        }
           
        function optionGenerateForBday(start, end, selectVal, elem) {
          Flits(elem).html("");
            for (i = start; i <= end; i++) {
                let opt = Flits("<option/>");
                let val = i < 10 ? "0" + i : i;
                opt.attr("value", val);
                opt.html(val);
                if (selectVal == val) {
                    opt.attr("selected", true);
                }
                Flits(elem).append(opt);
            }
        }
        optionGenerateForBday(1, 31, bDay, ".flits-dd-select select");
        optionGenerateForBday(1, 12, bMonth, ".flits-mm-select select");
        optionGenerateForBday(1920, new Date().getFullYear(), bYear, ".flits-yy-select select");
        Flits(".flits-profile-form-container").css("opacity","1");
    }, 0);
  });

  function getTodaysDateFormatted() {
    const today = new Date();
    const year = today.getFullYear();   
    // getMonth() returns month from 0-11. Add 1 to get the correct month number
    // padStart(2, '0') ensures that the month is 2 digits (01 for January, etc.)
    const month = (today.getMonth() + 1).toString().padStart(2, '0');    
    // getDate() returns the day of the month. padStart(2, '0') ensures 2 digits
    const day = today.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

}(Flits));
